export const handleBrokenImage = (imgLink) => {

    const imgLinkSplit = imgLink.split("https://");
    if (imgLinkSplit.length > 1) {
        const updatedLink = "https://" + imgLinkSplit[imgLinkSplit.length - 1];
        return updatedLink;
    } else {
        return "https://images.unitedwecare.com/odoo%2Fopen%2Fprofile-vector.webp"
    }
}

export const handleImage = (profileImage) => {
    // Logic to correct the broken image URL if needed
    const handleBrokenImage = (imgLink) => {
        const imgLinkSplit = imgLink.split("https://");

        if (imgLinkSplit.length > 1) {
            const updatedLink = "https://" + imgLinkSplit[imgLinkSplit.length - 1];
            return updatedLink;
        } else {
            return "https://images.unitedwecare.com/odoo%2Fopen%2Fprofile-vector.webp";
        }
    };

    // First, fix the image URL using your link splitting logic
    const fixedImageLink = handleBrokenImage(profileImage);

    // Return a promise that resolves to the final image URL
    return new Promise((resolve) => {
        const img = new Image();
        img.src = fixedImageLink;

        // If the image loads successfully, resolve to the fixed (and valid) image URL
        img.onload = () => resolve(fixedImageLink);

        // If the image fails, resolve to the fallback image URL (same as default)
        img.onerror = () => resolve("https://images.unitedwecare.com/odoo%2Fopen%2Fprofile-vector.webp");
    });
};

// Utility function to test UTC to local time conversion
export const testUTCTimeConversion = (utcTimestamp) => {
  const dayjs = require('dayjs');
  const utc = require('dayjs/plugin/utc');
  dayjs.extend(utc);
  
  try {
    const localTime = dayjs.utc(utcTimestamp).local().format('DD MMM YYYY hh:mm A');
    const utcTime = dayjs.utc(utcTimestamp).format('DD MMM YYYY hh:mm A');
    
    console.log('UTC Timestamp:', utcTimestamp);
    console.log('UTC Time:', utcTime);
    console.log('Local Time:', localTime);
    console.log('User Timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone);
    
    return {
      utcTime,
      localTime,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
  } catch (error) {
    console.error('Error converting UTC time:', error);
    return null;
  }
};
